import { ConferenceSiteSearch } from '@fs/zion-rootstech'
import { MinimumDashboardCreatorDetail } from './CreatorDetail'

export const DashboardConferenceSiteSearch = `
  ${MinimumDashboardCreatorDetail}
  ${ConferenceSiteSearch}
  fragment DashboardConferenceSiteSearch on ConferenceSiteSearch {
    ...ConferenceSiteSearch
    results {
      ...MinimumDashboardCreatorDetail
    }
  }
`
